// extracted by mini-css-extract-plugin
export default {"editor":"RichText_editor__jPmvt","toolbar":"RichText_toolbar__aFWVD","area":"RichText_area__8dGN5","split":"RichText_split__uaMPj","style":"RichText_style__DqD0z"};